import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "profile-creation-wizard__content-footer-buttons has-counter" }
const _hoisted_2 = ["data-testid"]
const _hoisted_3 = ["data-testid", "disabled"]
const _hoisted_4 = ["loading", "disabled", "data-testid"]
const _hoisted_5 = ["loading", "disabled", "data-testid"]

import ProfileCreationStepCounter from '@/profile-creation-wizard/common/ui/ProfileCreationStepCounter.vue';

    enum StepActionsEvents {
        CLICK_FINISH = 'click:finish',
        CLICK_NEXT = 'click:next',
        CLICK_PREVIOUS = 'click:previous',
        CLICK_SKIP = 'click:skip',
    }

    export interface Props {
        isDisabledButtonFinish?: boolean;
        showButtonFinish?: boolean;
        isLoadingButtonFinish?: boolean;
        // Next
        isDisabledButtonNext?: boolean;
        showButtonNext?: boolean;
        isLoadingButtonNext?: boolean;
        // Previous
        showButtonPrevious?: boolean;
        // Skip
        showButtonSkip?: boolean;
        isDisabledButtonSkip?: boolean;
    }
    
export default /*@__PURE__*/_defineComponent({
  __name: 'StepActions',
  props: {
    isDisabledButtonFinish: { type: Boolean, default: true },
    showButtonFinish: { type: Boolean, default: false },
    isLoadingButtonFinish: { type: Boolean, default: false },
    isDisabledButtonNext: { type: Boolean, default: true },
    showButtonNext: { type: Boolean, default: true },
    isLoadingButtonNext: { type: Boolean, default: false },
    showButtonPrevious: { type: Boolean, default: true },
    showButtonSkip: { type: Boolean, default: false },
    isDisabledButtonSkip: { type: Boolean, default: false }
  },
  setup(__props: any, { emit: __emit }) {

    const props = __props;

    const emit = __emit;

    function handleClickOnFinish(): void {
        emit(StepActionsEvents.CLICK_FINISH);
    }
    function handleClickOnNext(): void {
        emit(StepActionsEvents.CLICK_NEXT);
    }
    function handleClickOnPrevious(): void {
        emit(StepActionsEvents.CLICK_PREVIOUS);
    }
    function handleClickOnSkip(): void {
        emit(StepActionsEvents.CLICK_SKIP);
    }

    function dataTestId(action: string): string {
        return `step-actions-cta-${action}`;
    }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.showButtonPrevious)
      ? (_openBlock(), _createElementBlock("joy-button", {
          key: 0,
          class: "profile-creation-wizard__content-footer-previous",
          variant: "secondary",
          "data-previous-step": "",
          "data-testid": dataTestId('previous'),
          onClick: handleClickOnPrevious
        }, _toDisplayString(_ctx.$msg('generic.navigation.button.prev')), 9, _hoisted_2))
      : _createCommentVNode("", true),
    _createVNode(ProfileCreationStepCounter),
    (_ctx.showButtonSkip)
      ? (_openBlock(), _createElementBlock("joy-button", {
          key: 1,
          class: "profile-creation-wizard__step-action",
          variant: "ghost",
          "data-skip-step": "",
          "data-testid": dataTestId('skip'),
          disabled: _ctx.isDisabledButtonSkip,
          onClick: handleClickOnSkip
        }, _toDisplayString(_ctx.$msg('profile.creation.completion.wizard.steps.skip')), 9, _hoisted_3))
      : _createCommentVNode("", true),
    (_ctx.showButtonNext)
      ? (_openBlock(), _createElementBlock("joy-button", {
          key: 2,
          class: "profile-creation-wizard__step-action push-left has-counter",
          variant: "main",
          loading: _ctx.isLoadingButtonNext,
          disabled: _ctx.isDisabledButtonNext,
          "data-testid": dataTestId('next'),
          onClick: handleClickOnNext
        }, _toDisplayString(_ctx.$msg('generic.navigation.button.next')), 9, _hoisted_4))
      : _createCommentVNode("", true),
    (_ctx.showButtonFinish)
      ? (_openBlock(), _createElementBlock("joy-button", {
          key: 3,
          class: "profile-creation-wizard__step-action push-left has-counter",
          variant: "main",
          loading: _ctx.isLoadingButtonFinish,
          disabled: _ctx.isDisabledButtonFinish,
          "data-testid": dataTestId('finish'),
          "data-submit-step": "",
          onClick: handleClickOnFinish
        }, _toDisplayString(_ctx.$msg('profile.wizard.action.validate')), 9, _hoisted_5))
      : _createCommentVNode("", true)
  ]))
}
}

})